import React, { useEffect, useState } from "react";
import {
  ListBox,
  ListBoxToolbar,
  processListBoxData,
  processListBoxDragAndDrop,
} from "@progress/kendo-react-listbox";
import "./list-box-template.css";

const ListBoxTemplatePure = (props) => {
  const {
    listDataOne,
    listDataTwo,
    listResult,
    titleListOne,
    titleListTwo,
    loadingComponent,
    textField,
    item,
  } = props;

  //Take the selected from each list to use the list selection
  const SELECTED_FIELD = "selected";

  const [state, setState] = useState({
    listDataOne,
    listDataTwo,
    draggedItem: {},
  });

  //Change state lists with props
  useEffect(() => {
    setState({
      listDataOne,
      listDataTwo,
      loadingComponent: false,
      draggedItem: {},
    });
  }, [listDataOne, listDataTwo, loadingComponent]);

  // Get the result of the list to assigned profiles
  useEffect(() => {
    if (state.listDataOne.length > 0 || state.listDataTwo.length > 0) {
      listResult(state.listDataOne, state.listDataTwo);
    }
  }, [state]);

  const handleItemClick = (event, data, connectedData) => {
    setState({
      ...state,
      selected: true,
      [data]: state[data].map((item) => {
        if (
          item.name === event.dataItem.name &&
          item.userId === event.dataItem.userId
        ) {
          item[SELECTED_FIELD] = !item[SELECTED_FIELD];
        } else if (!event.nativeEvent.ctrlKey) {
          item[SELECTED_FIELD] = false;
        }
        return item;
      }),
      [connectedData]: state[connectedData].map((item) => {
        item[SELECTED_FIELD] = false;
        return item;
      }),
    });
  };

  const handleToolBarClick = (e, data, connectedData) => {
    let result = processListBoxData(
      state[data],
      state[connectedData],
      e.toolName,
      SELECTED_FIELD
    );
    setState({
      ...state,
      [data]: result.listBoxOneData,
      [connectedData]: result.listBoxTwoData,
    });
  };

  const handleDragStart = (e) => {
    let target = e.target;
    e.dataItem.dataCollection = target.props.name || "";
    setState({ ...state, draggedItem: e.dataItem });
  };

  const handleDrop = (e) => {
    let target = e.target;
    let dragItemData = state.draggedItem.dataCollection;
    let dropItemData = target.props.name;
    let result = processListBoxDragAndDrop(
      state[dragItemData],
      state[dropItemData],
      state.draggedItem,
      e.dataItem,
      "name"
    );
    setState({
      ...state,
      [dragItemData]: result.listBoxOneData,
      [dropItemData]: result.listBoxTwoData,
    });
  };

  return (
    <div className="listBoxTemplatePure-container ">
      <div className="listBoxTemplatePure-row">
        <div className="listBoxTemplatePure-col-listBox col-one-listBox">
          <h5 className="listBoxTemplatePure-titleList">{titleListOne}</h5>
          <ListBox
            name="listDataOne"
            style={
              state.listDataOne.length <= 0
                ? { height: "180px", width: "260px" }
                : { height: "auto", width: "260px" }
            }
            data={state.listDataOne}
            textField={textField}
            selectedField={SELECTED_FIELD}
            onItemClick={(e) =>
              handleItemClick(e, "listDataOne", "listDataTwo")
            }
            onDragStart={handleDragStart}
            onDrop={handleDrop}
            item={item}
            toolbar={() => {
              return (
                <ListBoxToolbar
                  tools={[
                    "transferTo",
                    "transferFrom",
                    "transferAllTo",
                    "transferAllFrom",
                  ]}
                  data={state.listDataOne}
                  dataConnected={state.listDataTwo}
                  onToolClick={(e) =>
                    handleToolBarClick(e, "listDataOne", "listDataTwo")
                  }
                  className="btn-toolBar"
                />
              );
            }}
          />
        </div>
        <div className="listBoxTemplatePure-col-listBox col-two-listBox">
          <h5 className="listBoxTemplatePure-titleList">{titleListTwo}</h5>
          <ListBox
            name="listDataTwo"
            style={
              state.listDataTwo.length <= 0
                ? { height: "183px", width: "200px" }
                : { height: "auto", width: "200px" }
            }
            data={state.listDataTwo}
            textField={textField}
            selectedField={SELECTED_FIELD}
            onItemClick={(e) =>
              handleItemClick(e, "listDataTwo", "listDataOne")
            }
            onDragStart={handleDragStart}
            onDrop={handleDrop}
            item={item}
          />
        </div>
      </div>
    </div>
  );
};

export { ListBoxTemplatePure as default };
